import styles from "./BedriftskundeInfo.module.less";
import { Heading } from "@digipost/dds-heading-react";
import Translated from "../infrastructure/translation/Translated";
import { PrimaryButton } from "@digipost/dds-buttons-react";
import { Link } from "react-router";

interface InfoBoxProps {
  showLoginButton?: boolean;
}

export function BedriftskundeInfo({ showLoginButton }: InfoBoxProps) {
  return (
    <article className={styles.infobox}>
      <Heading level={2} size={"small"} fontWeight={"bold"}>
        <Translated textKey={"infopage.customer_header"} />
      </Heading>
      <ul>
        <li>
          <Translated textKey={"infopage.usp_1"} />
        </li>
        <li>
          <Translated textKey={"infopage.usp_2"} />
        </li>
        <li>
          <Translated textKey={"infopage.usp_3"} />
        </li>
      </ul>
      {showLoginButton && (
        <PrimaryButton as={Link} to="/login">
          <Translated textKey={"infopage.button"} />
        </PrimaryButton>
      )}
      <img
        src={"/images/illustration/Hovedillustrasjon_barnehage_liten.svg"}
        alt={""}
        className={styles.illustration}
      />
    </article>
  );
}
